import { GroupsStore } from '@yarmill/types';
import { useRootStore } from './use-root-store';

export function useGroupsStore(): GroupsStore {
  return useRootStore().groupsStore;
}
